import React from 'react'
import { useDrop } from "react-dnd";
import { useBOMStore } from "../../hooks/bom";
import { useBOMProjectStore } from "../../hooks/bom_project";

export const Drop = (props) => {
    const [{ }, { }, { bom_assign_to_project }] = useBOMStore();
    const [{ }, { fetch_bom_project_detail_with_bom }] = useBOMProjectStore();
    const [{ }, dropRef] = useDrop({
        accept: 'BOX',
        drop: async (item) => {
            if (item?.dragFromProject === true || (item?.dragFromProject === false && props?.data?.projectId)) {
                let p = {};
                if (item?.data?.bomId) {
                    p.bomId = item.data.bomId;
                }
                if (props?.data && props?.data?.projectId) {
                    p.projectId = props.data.projectId;
                }

                if (Object.entries(p).length > 0) {
                    await bom_assign_to_project(p);
                    await fetch_bom_project_detail_with_bom();
                }
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })
    return (
        <div ref={dropRef}>
            {props.children}
        </div>
    )
}